import { Label } from '@/view/components/ui/label'
import { ImageOption } from './SelectedMaterial'
import { cn } from '@/app/utils/cn'

interface ImageTypeSelectProps {
  onClick: (value: ImageOption) => void
  options: {
    value: ImageOption
    label: string
    description: string
    quantity: number
    disabled: boolean
  }[]
}

export function ImageTypeSelect({ onClick, options }: ImageTypeSelectProps) {
  return (
    <div className="grid w-full grid-cols-2 gap-4">
      {options.map((option) => (
        <Label
          key={option.value}
          htmlFor={option.value}
          onClick={() => !option.disabled && onClick(option.value)}
          className={cn(
            'col-span-1 flex w-full items-center gap-3 rounded-lg border border-primary p-3 transition-all hover:border-primary/30',
            option.disabled && 'border-black04 bg-gray-100',
          )}
        >
          <div className="flex flex-col gap-1">
            <p
              className={cn(
                'text-sm font-semibold',
                option.disabled && 'text-black04',
              )}
            >
              {option.label}
              <span className="ml-2 text-xs font-normal text-muted-foreground">
                ({option.quantity})
              </span>
            </p>
            <p className="text-xs text-black04">{option.description}</p>
          </div>
        </Label>
      ))}
    </div>
  )
}
